import type { ProfileSection } from '@shared/index';

export const profileSectionToAnalyticEvent: Record<ProfileSection, string> = {
  'personal-data': 'personal_data',
  contacts: 'contacts',
  address: 'address',
  'bank-details': 'requisites',
};
